import React, { useEffect } from 'react'
import { Box } from '@chakra-ui/core'
import axios from 'axios'
import { settings } from '../../config/settings'

let isAppReady = false
window.addEventListener('flutterInAppWebViewPlatformReady', function () {
  isAppReady = true
})

type SpallaStatsEventDetail = {
    uid: string;
    currentTime: number;
    duration: number;
    ended: boolean;
    paused: boolean;
    played: number;
    playedIntervals: Array<{ start: number; end: number }>;
    playedPercent: number;
};

const MobileSambaPlayer = ({ match }): JSX.Element => {
  const idPlayer = 'player'
  let updatedInfo = false
  const init = () => {
    // clearPlayer();

    (window as typeof globalThis).Spalla = (window as typeof globalThis).Spalla || {};
    (window as typeof globalThis).Spalla.config = {
      element: '#' + idPlayer,
      stream: reference,
      autoplay: false,
      bar: true,
      search: false,
      audioplayer: false,
      offline: false,
      t: (progress && watched) ? progress : 0,
      info: 0,
      subtitlePosition: 'inner',
      aid: playerKey
    }

    const script = document.createElement('script')
    script.src = 'https://beyond.spalla.io/player/js/spalla-player.js'
    script.async = true
    document.body.appendChild(script)

    addEventListener().then()
  }

  useEffect(() => {
    init()
  }, [init])

  let { contentId, playerKey, progress, watched, reference, token } = match.params

  watched = JSON.parse(watched ?? 'false')

  const dispatchActionView = async (currentProgress: number, playedPercent: number): Promise<void> => {
    if (!watched && contentId && currentProgress > progress && !updatedInfo) {
      if (Math.round(playedPercent) > 50) {
        await axios.post(`${settings.API_URL}/user_collection_views`, {
          content: `/v1/contents/${contentId}`,
          percent: Math.round(playedPercent) || 100,
          progress: currentProgress
        }, {
          headers: {
            Authorization: token
          }
        })
        updatedInfo = true
      }
    }
  }

  const addEventListener = async (): Promise<void> => {
    window.addEventListener('spalla_player_stats', async (e) => {
      const event = e as CustomEvent<SpallaStatsEventDetail>
      const { currentTime, duration } = event.detail
      const playedPercent = (currentTime / duration) * 100

      if (currentTime > 1 && Math.round(playedPercent) <= 50 && currentTime % 10 === 0) { // update a cada 10 segundos
        if (isAppReady) {
          try {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            window.flutter_inappwebview.callHandler('sendViewPercent', currentTime, duration * 1000)
          } catch (e) {
            // ignore
          }
        }
        await dispatchActionView(currentTime, Math.round(playedPercent))
      } else if (currentTime > 1 && Math.round(playedPercent) > 50 && !watched) {
        watched = true
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        window.flutter_inappwebview.callHandler('sendViewPercent', currentTime, duration * 1000)
        await dispatchActionView(duration, 100)
      }
    }, false)

    window.addEventListener('spalla_player_ended', async (event) => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      await dispatchActionView(event.detail.duration, 100)
      if (isAppReady) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        window.flutter_inappwebview.callHandler('sendViewPercent', event.detail.duration, event.detail.duration * 1000)
      }
    })

    /* switch (player.event) {
              case 'onListen':
                if (!flagAppUpdate && eventParam > 1 && eventParam % 5 === 0) {
                  flagAppUpdate = true
                  if (isAppReady) {
                    try {
                      // @ts-ignore
                      window.flutter_inappwebview.callHandler('sendViewPercent', eventParam, player.duration)
                    } catch (e) {
                      // ignore
                    }
                  }
                } else if (flagAppUpdate && eventParam > 1 && (eventParam - 1) % 5 === 0) { flagAppUpdate = false }

                if (!flag && eventParam > 1 && eventParam % 15 === 0) {
                  await dispatchActionView(eventParam, player.duration)
                } else if (flag && eventParam > 1 && eventParam % 16 === 0) {
                  flag = false
                }
                break
              case 'onFinish':
                if (isAppReady) {
                  // @ts-ignore
                  window.flutter_inappwebview.callHandler('sendViewPercent', player.duration / 1000, player.duration)
                }
                await dispatchActionView(player.duration / 1000, player.duration)
                break
              default: break
            } */
  }

  return (
    <Box pos="relative" overflow="hidden" w="100%" h="100vh">
      <Box pos="absolute" left={0} right={0} bottom={0} top={0} w="100%" id={idPlayer}/>
    </Box>
  )
}

export default MobileSambaPlayer
